import { createSlice } from "@reduxjs/toolkit";
import { supplierContactByBrand } from "./supplierAsyncThunk";

const supplierContactByBrandSlice = createSlice({
  name: "supplier",
  initialState: {
    payload: "",
    isLoading: false,
    isSuccess: false,
    isFail: false,
  },
  reducers: {},
  extraReducers: {
    [supplierContactByBrand.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isFail = false;
    },
    [supplierContactByBrand.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.payload = action.payload.supplier;
    },
    [supplierContactByBrand.rejected]: (state, action) => {
      state.isLoading = false;
      state.isFail = true;
    },
  },
});

export default supplierContactByBrandSlice.reducer;
